// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__37KdG","detailsBorder":"styles_detailsBorder__1SGOy"};